import { forwardRef, InputHTMLAttributes } from "react";

interface FormInputProps extends InputHTMLAttributes<HTMLInputElement> {
    label: string;
}

export const FormInput = forwardRef<HTMLInputElement, FormInputProps>(({ label, ...props }, ref) => {
    return (
        <div>
            <label className="text-sm font-semibold">{label}</label>
            <input
                ref={ref}
                className="
                    w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2
                    font-semibold text-gray-600 text-sm bg-white"
                {...props} />
        </div>
    );
});

FormInput.displayName = 'FormInput';


interface InlineFormInputProps extends InputHTMLAttributes<HTMLInputElement> {
    label: string;
    icon?: React.ReactNode;
    labelWidth?: number;
}

export const InlineFormInput = forwardRef<HTMLInputElement, InlineFormInputProps>(({ label, icon, labelWidth = 154, ...props }, ref) => {

    return (
        <div className="flex items-center gap-x-2">
            <div className="flex items-center  gap-x-1">
                {icon}
                <label
                    style={{ minWidth: labelWidth }}
                    className={`font-semibold truncate`}>{label}</label>
            </div>

            <input
                ref={ref}
                className="
                    rounded-[3px] border-gray-400 border my-1 px-2 flex-1
                    font-semibold text-gray-600 text-sm w-full"
                {...props}/>
        </div>
    );
});

InlineFormInput.displayName = "InlineFormInput";
